<template>
  <div class="customer_service_question_history">
    <div class="question_history">
      <el-table
        v-loading="historyListLoading"
        class="question_history_table"
        :data="historyList"
        row-key="issueId"
        highlight-current-row
        :row-style="{ cursor: 'pointer' }"
        :header-cell-style="
          ({ columnIndex }) => {
            if (columnIndex === 0) {
              return { paddingLeft: '50px', background: '#f4f4f4' }
            } else {
              return { background: '#f4f4f4' }
            }
          }
        "
        :cell-style="
          ({ columnIndex }) => {
            if (columnIndex === 0) {
              return { paddingLeft: '50px' }
            } else {
              return {}
            }
          }
        "
        @row-click="goIDPage"
      >
        <el-table-column
          width="190px"
          prop="issueId"
          label="问题编号"
        ></el-table-column>
        <el-table-column
          width="190px"
          prop="addTime"
          label="时间"
        ></el-table-column>
        <el-table-column
          width="190px"
          label="渠道"
          :formatter="
            (row, cloumn) => {
              return `${row.gameName}-${row.serverName}`
            }
          "
        ></el-table-column>
        <el-table-column
          width="120px"
          prop="subTypeName"
          label="业务"
        ></el-table-column>
        <el-table-column
          width="190px"
          prop="detail"
          label="内容"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="status" label="备注">
          <template v-slot="data">
            <el-badge
              v-if="data.row.status === 6"
              :value="1"
              style="margin: 10px 0;"
            >
              <el-tag size="small" :style="statusStyle(data.row)">{{
                statusValue(data.row)
              }}</el-tag>
            </el-badge>
            <el-tag
              v-else
              size="small"
              style="margin: 10px 0;"
              :style="statusStyle(data.row)"
              >{{ statusValue(data.row) }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="question_history_pagi">
        <el-pagination
          style="float: right;"
          layout="total, sizes, prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="historyListPageSize"
          :current-page="historyListPageID"
          :total="historyListTotalCount"
          @size-change="historyListSizeChange"
          @current-change="historyListPageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    historyStatusMap: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      historyListLoading: false,
      historyList: [],
      historyListPageID: 1,
      historyListPageSize: 5,
      historyListTotalCount: 0
    }
  },
  mounted() {},
  methods: {
    clientCreated() {
      if (this.$store.getters.isLogin) {
        this.getHistoryList()
      }
    },
    async getHistoryList(
      page = this.historyListPageID,
      pageSize = this.historyListPageSize
    ) {
      this.historyListLoading = true
      const res = await this.$util
        .f2eAjax({
          url: '//customer.game.yy.com/gmCenter/user/xlIssue/list.do',
          data: {
            page,
            pageSize
          }
        })
        .catch(() => {})
      if (
        res &&
        res.data &&
        res.data.issueList &&
        res.data.issueList.length > 0
      ) {
        this.historyList = res.data.issueList
      } else {
        this.historyList = []
      }
      if (res && res.data && res.data.userAllCount > 0) {
        this.historyListTotalCount = res.data.userAllCount
      } else {
        this.historyListTotalCount = 0
      }
      this.historyListLoading = false
    },
    async historyListSizeChange(pageSize = this.historyListPageSize) {
      this.historyListPageSize = pageSize
      await this.getHistoryList()
    },
    async historyListPageChange(page = this.historyListPageID) {
      this.historyListPageID = page
      await this.getHistoryList()
    },
    statusStyle(row) {
      const _conf = this.historyStatusMap[row.status]
      if (_conf && _conf.style) {
        return _conf.style
      } else {
        return { background: '#a0a0a0', color: '#ffffff' }
      }
    },
    statusValue(row) {
      const _conf = this.historyStatusMap[row.status]
      if (_conf && _conf.label) {
        return _conf.label
      } else {
        return '未知'
      }
    },
    goIDPage(row) {
      this.$router.push(`/customer/question/${row.issueId}`)
    }
  }
}
</script>
